import api from './categoryApi';
// axios
import request, { enhancedService } from '@/utils/request';

// 获取分类列表
export function getCategoryList(data) {
  return enhancedService({
    url: api.categoryList,
    method: 'get',
    params: data,
  });
}
// 获取分类列表
export function getCateGoryByLevelAndSchoolIdApi(data) {
  return enhancedService({
    url: api.getCateGoryByLevelAndSchoolIdApi,
    method: 'get',
    params: data,
  });
}

// 根据分类获取电子书列表
export function getEbookList(data) {
  return request({
    url: api.ebookList,
    method: 'get',
    params: data,
  });
}

// 获取电子书类型列表
export function getEbookTypeList(data) {
  return request({
    url: api.ebookTypeList,
    method: 'get',
    params: data,
  });
}

// 用户信息 post 方法
export function getUserInfo(data) {
  return request({
    url: api.UserInfo,
    method: 'post',
    data,
    hideloading: true,
  });
}

// 用户名称 get 方法
export function getUserName(params) {
  return request({
    url: api.UserName,
    method: 'get',
    params,
    hideloading: true,
  });
}

// 记录点击分类数量
export function addClickNumApi(params) {
  return request({
    url: `/webApi/category/addClickNum?id=${params}`,
    method: 'get',
    // params,
    hideloading: true,
  });
}

